import { Container } from '@components/Container'
import { formatDateDomini } from '@lib/utils'
import { SearchSaleAnalytics } from '../SaleAnalyticsTab/components/SearchSaleAnalytics'
import { SaleAnalyticsOverviewProps } from './interface'
import { OverviewHeader } from './components/OverviewHeader'
import { OverviewTabs } from './components/OverviewTabs'

export function SaleAnalyticsOverview({
  data,
  initialValues,
  startDate,
  endDate,
  queryParams,
  handleSearch,
}: SaleAnalyticsOverviewProps) {
  return (
    <Container>
      <div className='grid gap-y-[20px] mobile:mt-[20px]'>
        <SearchSaleAnalytics
          queryParams={queryParams}
          initialValues={initialValues}
          handleSubmit={handleSearch}
        />
        <hr className='w-full border-t border-gray-3 dark:border-purple' />
        <div>
          <div className='font-light text-[14px] text-secondary-1 mb-[30px] tablet-mobile:mb-[20px]'>
            {`ข้อมูล ณ วันที่ ${formatDateDomini(
              startDate.toString(),
              false
            )} - ${formatDateDomini(endDate.toString(), false)}`}
          </div>
          {data.bookType || data.bookTitle ? (
            <div className='flex items-center text-secondary mb-[30px]'>
              <div className='font-light border-r border-gray-3 pr-[20px] mr-[20px]'>
                {data.bookType}
              </div>
              <div className='font-mitr font-medium line-clamp-1 leading-[1.8]'>
                {data.bookTitle}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <OverviewHeader
        sales={data.sales}
        donation={data.donation}
        viewCount={data.viewCount}
        likeCount={data.likeCount}
        shelfAddedCount={data.shelfAddedCount}
        commentCount={data.commentCount}
        genderDetail={data.genderDetail}
        ageDetail={data.ageDetail}
      />
      <OverviewTabs queryParams={queryParams} />
    </Container>
  )
}
